export const payorTypes = [
  {
    value: 'Individual',
    label: 'Individual',
  },
  {
    value: 'Juridical',
    label: 'Juridical',
  },
]
